<template>
  <crud-layout
    :title="title"
    :subtitle="subtitle"
    :add-button="true"
    @add="create"
  >
    <template v-slot:list>
      <marca-list
        ref="list"
        @update="update"
        @delete="remove"
        @show="show"
      />
    </template>

    <marca-create
      v-if="creating"
      :open="creating"
      v-on:itemCreated="onItemCreated"
      v-on:close="creating = false"
    />

    <marca-update
      v-if="updating"
      :open="updating"
      :item="itemToEdit"
      v-on:itemUpdated="onItemUpdated"
      v-on:close="updating = false"
    />

    <marca-show
      v-if="showing"
      :open="showing"
      :item="itemToShow"
      v-on:close="showing = false"
    />

    <marca-delete
      v-if="deleting"
      :open="deleting"
      :item="itemToDelete"
      v-on:itemDeleted="onItemDeleted"
      v-on:close="deleting = false"
    />

    <snackbar v-model="flash" />
  </crud-layout>
</template>

<script>
import MarcaCreate from "../MarcaCreate";
import MarcaUpdate from "../MarcaUpdate";
import MarcaDelete from "../MarcaDelete";
import MarcaShow from "../MarcaShow";
import MarcaList from "../MarcaList";

import { CrudLayout, Snackbar } from "@dracul/common-frontend";

export default {
  name: "MarcaCrud",
  components: {
    CrudLayout,
    Snackbar,
    MarcaCreate,
    MarcaUpdate,
    MarcaDelete,
    MarcaShow,
    MarcaList,
  },
  data() {
    return {
      title: "marca.title",
      subtitle: "marca.subtitle",
      flash: null,
      creating: false,
      updating: false,
      deleting: false,
      showing: false,
      itemToEdit: null,
      itemToDelete: null,
      itemToShow: null,
    };
  },
  methods: {
    //On
    onItemCreated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.created");
    },
    onItemUpdated() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.updated");
    },
    onItemDeleted() {
      this.$refs.list.fetch();
      this.flash = this.$t("common.deleted");
    },
    //Open
    create() {
      this.creating = true;
    },
    update(item) {
      this.updating = true;
      this.itemToEdit = item;
    },
    show(item) {
      this.showing = true;
      this.itemToShow = item;
    },
    remove(item) {
      this.deleting = true;
      this.itemToDelete = item;
    },
  },
};
</script>


